export const baseURL = "https://db.fuelmotioninc.com";
  // "https://fmi-endpoints-dot-red-context-247809.el.r.appspot.com"; 
 //"http://localhost:9001"; //"https://35.200.224.10:9001";

export const loginEndPoint = baseURL + "/login";
export const emsLevelURL = "/emsLevel";
export const emsList = "/emsList";
export const emsGraphData = "/emsGraphData";
export const recData = "/rectifier";
export const emsRegistrationEndPoint = baseURL + "/emsRegistration";
export const registeredEmsEndPoint = baseURL + "/registeredEms";
export const userRegistrationEndPoint = baseURL + "/userRegistration";
export const batteryMetricsEndpoint = baseURL + "/battery-metrics";

// export const webSockLink = "wss://192.168.8.104:8443";
// export const webSockLink = "ws://192.168.8.102:9000";
// export const webSockLink = "wss://35.200.252.189:8443";
// export const webSockLink = "wss://34.100.211.67:9000";
// export const webSockLink = "wss://fuelmotioninc.com:9000";
export const webSockLink = "https://mqtt.fuelmotioninc.com";
  // "https://fmi-streamer-dot-red-context-247809.el.r.appspot.com/"; 
//  "http://localhost:9000";
// M = MainContactor,C = ChargingContactor
export const TAG_BATTERY_STATUS_00 = "OFF|OFF";
export const TAG_BATTERY_STATUS_01 =
  "ON|OFF";
export const TAG_BATTERY_STATUS_10 =
  "OFF|ON";
export const TAG_BATTERY_STATUS_11 = "ON|ON";

export const TAG_BATTERY_STATUS_0000 =
  "No Balancing Operation is being performed";
export const TAG_BATTERY_STATUS_0001 = "Cell Balancing is in progress";
export const TAG_BATTERY_STATUS_0010 = "Pack balancing is in progress";
export const TAG_BATTERY_STATUS_0100 = "Balancing has been done";
export const TAG_BATTERY_STATUS_1000 = "Charging in between Balancing";

export const TAG_BATTERY_STATUS_0 = "Deactivated";
export const TAG_BATTERY_STATUS_1 = "Activated";

export const TAG_CHARGER_STATUS_00 = "Not Charging";
export const TAG_CHARGER_STATUS_01 = "Charging";
export const TAG_CHARGER_STATUS_10 = "Idle";

// --------------------------------------BMS Error-------------------------------------//

export const KEY_CELL_UNDER_VOLTAGE = "CELL UNDER VOLTAGE ERROR";
export const KEY_CELL_OVER_VOLTAGE = "CELL OVER VOLTAGE ERROR";

export const KEY_OVER_TEMPERATURE_ERROR = "OVER TEMPERATURE ERROR";
export const KEY_CAN_COMMUNICATION_ERROR = "CAN COMMUNICATION ERROR";
export const KEY_MAIN_CONTACTOR_FAULTY_ERROR = "MAIN CONTACTOR FAULTY ERROR";
export const KEY_CHARGING_CONTACTOR_FAULTY_ERROR =
  "CHARGING CONTACTOR FAULTY ERROR";
export const KEY_DC_BUS_OVER_CURRENT_ERROR = "DC BUS OVER CURRENT ERROR";
export const KEY_CELLS_BALANCING_ERROR = "CELLS BALANCING ERROR";
export const KEY_SOC_ERROR = "SOC ERROR";

export const KEY_NO_ERROR = "NO ERROR";

////////// ----------------------- BMS ERROR 2 ----------------------------------------/////////

//

export const KEY_SLAVE_DEAD_ERROR = "Slave Dead Error";
export const KEY_FAULTY_CHARGING_ERROR = "Faulty Charging Contactor Error";

//------------------------- INVERTER ERROR --------------------------------/////

export const KEY_OVER_LOAD_ERROR = "OVERLOAD ERROR";
export const KEY_SHORT_CIRCUIT_ERROR = "SHORT CIRCUIT";
export const KEY_IPM_ERROR = "IPM ERROR";
export const KEY_OTW_ERROR = "Over Temperature Warning";
export const KEY_SOW_ERROR = "System Overload Warning";
export const KEY_ERROR = "ERROR";

//------------------------- RECTIFIER ERROR 1--------------------------------/////

export const KEY_REC_FAN_ERROR = "Fan Error";
export const KEY_REC_OVER_TEMPERATURE_ERROR = "Over Temperature Error";
export const KEY_REC_OUTPUT_OVER_VOLTAGE_ERROR = "Output Over Voltage Error";
export const KEY_REC_COMMAND_NOT_SEND_ERROR = "Command not send in 10 seconds";
export const KEY_REC_POWER_LIMIT_FLAG_ERROR = "Power Limit Flag";
export const KEY_REC_INPUT_PHASE_LOST_ERROR = "Input Phase Lost";
export const KEY_REC_INPUT_PHASE_UNBALANCE_ERROR = "Input Phase Unbalance";
export const KEY_REC_INPUT_UNDER_VOLTAGE_ERROR = "Input Under Voltage";

//------------------------- RECTIFIER ERROR 2--------------------------------/////

export const KEY_REC_INPUT_OVER_VOLTAGE_ERROR = "Input Over Voltage";
export const KEY_REC_PFC_OFF_ERROR = "PFC OFF";
